import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { schuurTuinhuisDordrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/schuur-tuinhuis-laten-bouwen")({
  head: () => dienstLocatieHead(schuurTuinhuisDordrecht),
  component: () => <DienstLocatiePage content={schuurTuinhuisDordrecht} />,
});
